import { FormDialogConfig, Icon } from '@aibees/shared/components';
import { yup } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';

export const config: FormDialogConfig = {
  title: (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <Icon size={20} name="published-with-changes" color="primary.400" />
      <Typography variant="body2">Change Ownership</Typography>
    </Stack>
  ),
  closeButton: {
    children: 'Cancel',
    variant: 'text',
    sx: { border: 0 },
  },
};

export const scheme = yup.object().shape({
  newOwner: yup
    .string()
    .required('Please choose a Team Member before submitting.'),
});
